import { defineComponent, reactive, ref } from "vue";
import { useRouter } from "vue-router";
import KaiyakuEntryHasonTable from "./components/KaiyakuEntryHasonTable.vue";
import BreadcrumbList from "~/components/BreadcrumbList.vue";
import { api } from "~/api";
import { MsgBox } from "~/components/MsgBox";
import { Log } from "~/extensions/utils";
import { store } from "../store/TaikyoStore";
import { myPageStore } from "~/store/MyPageStore";
import { commonStore } from "~/store/CommonStore";
import { PageID } from "~/extensions/utils/DefineTypes";
import { KaiyakuEntryHasonPageValidator } from "./Models/KaiyakuEntryPageValidator";
const log = Log.create("KaiyakuEntryHasonPage");
// エラーメッセージ定数
const ERROR_MESSAGES = {
    REQUIRED_HASON: "修繕項目を選択するか、記入スペースに入力してください。"
};
export default defineComponent({
    name: "KaiyakuEntryHasonPage",
    components: {
        KaiyakuEntryHasonTable,
        BreadcrumbList
    },
    beforeRouteEnter(to, from, next) {
        const fromScreen = from.name;
        const relatedScreens = ["kaiyaku-entry", "kaiyaku-entry-check"];
        const relatedNotificationScreens = ["taikyo-notification-entry", "taikyo-notification-entry-check"];
        if (relatedScreens.includes(fromScreen) && store.taikyoEntity.status === 2) {
            next();
            return;
        }
        if (relatedNotificationScreens.includes(fromScreen)) {
            next();
            return;
        }
        next({ name: "taikyo" });
    },
    async setup() {
        const router = useRouter();
        // ページ情報
        const pageName = commonStore.pageName(PageID.kaiyakuEntryHason);
        const isMultipleKeiyaku = myPageStore.isMultipleKeiyaku;
        // ページから遷移元を判定（通知または解約）
        const isNotification = ref(false);
        // HTMLコンテンツ
        const html = ref("");
        // ストアデータ
        const hasonInfo = reactive(store.hasonInfo);
        // 参照
        const hasonTable = ref();
        /**
         * HTMLテキスト読み込み
         */
        const initView = async () => {
            try {
                html.value = await api.kaiyaku.loadHasonText();
            }
            catch (ex) {
                log.error("loadHasonText", ex);
                if (ex.data?.status !== 404) {
                    MsgBox.error(ex.message);
                }
            }
        };
        // バリデータを初期化
        const valid = reactive(new KaiyakuEntryHasonPageValidator(hasonInfo));
        /**
         * 確認画面へ遷移
         */
        const apply = () => {
            if (valid.error) {
                MsgBox.error(ERROR_MESSAGES.REQUIRED_HASON);
                return;
            }
            // 破損なしが未選択で、かつ何も記入されていない場合はエラー
            if (!hasonInfo.isNothing) {
                const anySelected = hasonInfo.hasonList.some(hason => hason.isSelected);
                const hasRemarks = hasonInfo.remarks && hasonInfo.remarks.trim().length > 0;
                if (!anySelected && !hasRemarks) {
                    MsgBox.error(ERROR_MESSAGES.REQUIRED_HASON);
                    return;
                }
            }
            const nextRouteName = isNotification.value ? "taikyo-notification-entry-check" : "kaiyaku-entry-check";
            router.push({ name: nextRouteName });
        };
        // 初期化
        await initView();
        return {
            // ページ情報
            pageName,
            PageID,
            router,
            isMultipleKeiyaku,
            // コンテンツ
            html,
            hasonInfo,
            // フラグ
            isNotification,
            // 参照
            hasonTable,
            // ハンドラー
            apply
        };
    }
});
